import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { withApollo } from "@apollo/client/react/hoc";
import SButton from "styled42/components/SButton";
import SText from "styled42/components/SText";
import { Colors } from "styled42/config";
import { pushClevertapEvent } from "utils/clevertapEvents";
import S3Image from "screens/common/S3Image";
import ArrowNext from "icons/ArrowNext";
import NavHeader from "screens/LoginRegistration/utils/NavHeader";
import VernacManager from "utils/vernacular";
import ComponentHeader from "../utils/ComponentHeader";
//import DateComponent from "./DateComponent";
import NameComponent from "./NameComponent";
import GenderComponent from "./GenderComponent";
//import QualificationComponent from "./QualificationComponent";
import { getInitialStateValue, onSubmitHandler } from "./utils";

export const TickComponent = () => (
  <View>
    <S3Image
      name="Tick_onboarding"
      path="RocketIntegration"
      style={{ height: 12, width: 12, marginRight: 6 }}
    />
  </View>
);

class BasicDetailComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      state: { user }
    } = props;

    const { fullName, gender, proficiencyLevel, dob, educationId } =
      getInitialStateValue({ user });

    this.state = {
      fullName,
      educationId,
      gender,
      dob: dob || "",
      qualification: proficiencyLevel
    };
    this.typedFirstKeyword = false;
  }

  componentDidMount = () => {
    const {
      state: { variant }
    } = this.props;
    pushClevertapEvent("Page Load", {
      Current_Page: "New loginRegistration",
      Test_Case: variant,
      Page_Modal: "Personal Details Page 1"
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { fullName } = this.state;

    if (
      prevState.fullName === "" &&
      prevState.fullName !== fullName &&
      !this.typedFirstKeyword
    ) {
      const {
        state: { variant }
      } = this.props;
      //  To detect when user has typed the first character
      pushClevertapEvent("loginRegister Clicks", {
        Page_Modal: "Personal Details Page 1",
        Current_Page: "New loginRegistration",
        Test_Case: variant,
        Type: "Name"
      });

      this.typedFirstKeyword = true;
    }
  }

  handleStateChange = ({ component, value }) => {
    this.setState({
      [component]: value
    });
  };

  onClickHandler = async () => {
    const { fullName, gender, dob, qualification, educationId } = this.state;
    const { goNext, client, state } = this.props;

    onSubmitHandler({
      goNext,
      client,
      state,
      fullName,
      gender,
      dob,
      qualification,
      educationId
    });
  };

  enableContinueFunc = () => {
    const { fullName, gender, dob, qualification } = this.state;
    let enContinue = false;
    // if (fullName && gender && dob && qualification) {
    if (fullName && gender) {
      enContinue = true;
    }
    return enContinue;
  };

  render() {
    const { fullName, gender, dob, qualification } = this.state;
    const {
      state: { variant }
    } = this.props;

    return (
      <View style={styles.root}>
        <NavHeader
          progressStatus={1}
          maxValue={variant === "B" ? 2 : 3}
          containerStyle={{ backgroundColor: "transparent" }}
        />
        <ScrollView
          style={styles.container}
          showsVerticalScrollIndicator={false}
        >
          <ComponentHeader
            title={VernacManager.translateString("generic_create_account")}
          />
          <View style={styles.noFeeContainer}>
            {/* <TickComponent /> */}
            <SText size={12} color="secondary">
              {VernacManager.translateString("create_account_access_jobs")}
            </SText>
          </View>
          <View>
            <NameComponent
              value={fullName}
              handleStateChange={this.handleStateChange}
            />
            {/* <DateComponent
              value={dob}
              handleStateChange={this.handleStateChange}
            /> */}
            <GenderComponent
              value={gender}
              handleStateChange={this.handleStateChange}
              variant={variant}
            />
            {/* <QualificationComponent
              value={qualification}
              handleStateChange={this.handleStateChange}
            /> */}
          </View>
        </ScrollView>
        <View style={styles.submitContainer}>
          <SButton
            type="primary"
            text={VernacManager.translateString("generic_next")}
            suffixIcon={ArrowNext}
            disabled={!this.enableContinueFunc()}
            textProps={{
              size: 14,
              color: Colors.White[1]
            }}
            onClick={this.onClickHandler}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    height: "100%",
    backgroundColor: "transparent" //Colors.White[1]
  },
  container: {
    paddingHorizontal: 16
  },
  noFeeContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 4,
    marginLeft: 0,
    marginBottom: 16
  },
  submitContainer: {
    backgroundColor: "transparent", //Colors.White[1],
    width: "100%",
    padding: 16
  },
  tickContainer: {
    // width: 12,
    // height: 12,
    // marginRight: 4,
    // paddingTop: 2,
    // alignItems: "center",
    // borderRadius: 6,
    // backgroundColor: Colors.Green[5],
    // right: 0,
    // top: 0
  },
  tick: {
    transform: [{ rotate: "45deg" }],
    height: 6,
    width: 4,
    borderColor: Colors.White[1],
    borderBottomWidth: 2,
    borderRightWidth: 2
  }
});

export default withApollo(BasicDetailComponent);
